import { Box, styled } from '@mui/joy'

export const Wrapper = styled(Box)`
  width: 100%;
  height: 100%;
`
